/**
 * @typedef {import('./api').Auth0MfaAuthenticatorType} Auth0MfaAuthenticatorType
 * @typedef {import('./api').Auth0ManagementMfaType} Auth0ManagementMfaType
 */

/**
 * @type {{ [key: string]: Auth0MfaAuthenticatorType}}
 */
export const CHALLENGE_TYPES = {
  OOB: 'oob',
  OTP: 'otp',
  RECOVERY_CODE: 'recovery_code',
};

/**
 * @type {{ [key: string]: Auth0ManagementMfaType}}
 */
export const MANAGEMENT_TYPES = {
  EMAIL: 'email',
  PHONE: 'phone',
  RECOVERY_CODE: 'recovery-code',
  TOTP: 'totp',
  PASSKEY: 'passkey',
  PUSH: 'push',
};

/**
 * @type {{ [key: string]: Auth0MfaAuthenticatorType}}
 */
export const mapManagementApiTypeToAuthenticationApiChallengeType = {
  [MANAGEMENT_TYPES.EMAIL]: CHALLENGE_TYPES.OOB,
  [MANAGEMENT_TYPES.PHONE]: CHALLENGE_TYPES.OOB,
  [MANAGEMENT_TYPES.RECOVERY_CODE]: CHALLENGE_TYPES.RECOVERY_CODE,
  [MANAGEMENT_TYPES.TOTP]: CHALLENGE_TYPES.OTP,
  [MANAGEMENT_TYPES.PASSKEY]: CHALLENGE_TYPES.OTP,
  [MANAGEMENT_TYPES.PUSH]: CHALLENGE_TYPES.OOB,
};

export const TokenTimeoutError = {
  code: 6000,
  message: 'The mfa_token provided is invalid. Try getting a new token.',
  message2: 'mfa_token is expired',
};
